import { Stack, Typography } from '@mui/material'

export const TransactionsTab = () => {
  return (
    // <Stack className="px-6 pt-8">
    //   <Typography className="text-base font-bold text-zBlack200">
    //     História transakcií
    //   </Typography>

    //   <Stack className="gap-2 pt-4">
    //     {transactions.map((trans) => (
    //       <Stack key={trans.id} className="p-4 bg-zGrey200 rounded-4d">
    //         <Stack className="flex-row justify-between pr-4">
    //           <Typography className="text-xs font-medium text-zGrey400">
    //             {`ID transakcie: ${trans.id.replace(/[^0-9]/g, '')}`}
    //           </Typography>
    //           <Typography className="text-xs font-medium text-zGrey400">
    //             {new Date(trans.createdAt).toLocaleDateString('sk-SK')}
    //           </Typography>
    //         </Stack>

    //         <Stack className="gap-1 pt-2">
    //           <Typography className="text-3d font-medium text-zGrey300">
    //             {trans.type}
    //           </Typography>
    //           <Stack className="flex-row items-center gap-1.5">
    //             <Typography className="text-xl font-bold text-zBlack200 tabular-nums">
    //               {`${Math.floor(trans.amount).toLocaleString('sk-SK')} €`}
    //             </Typography>
    //             <ArrowTransactionSvg className="mr-auto" />
    //             <Typography className="text-xs font-semibold text-zGrey300">
    //               {trans.senderIBAN}
    //             </Typography>
    //           </Stack>
    //         </Stack>
    //       </Stack>
    //     ))}
    //   </Stack>
    // </Stack>
    <Stack className="px-6 pt-8">
      <Typography className="text-3d font-medium text-zGrey400 text-center">
        Nemáte žiadne transakcie.
      </Typography>
    </Stack>
  )
}
